import React from 'react';
import { Trans } from '@lingui/react';
import classNames from 'classnames';
import './HomeServiceCardDetails.css';

type Props = {
  activeCardTitle: any;
  activeCardContent: any;
  activeCardKey: number;
};

export const HomeServiceCardDetails: React.FunctionComponent<Props> = ({
  activeCardKey,
  activeCardTitle,
  activeCardContent,
}: Props) => {
  const detailsClass = classNames('wrapper', {
    'hide-wrapper': activeCardKey === -1,
  });

  return (
    <div className={detailsClass}>
      <div className="pr-md-5 details-animation">
        <h3>{activeCardTitle}</h3>
        <p>{activeCardContent}</p>

        {activeCardKey == 5 && (
          <ul className="list-unstyled mt-5">
            <li className="py-2">
              <div className="d-flex align-items-center">
                <div>
                  <div className="badge badge-circle badge-primary mr-3">
                    <i className="ni ni-check-bold"></i>
                  </div>
                </div>
                <div>
                  <h6 className="mb-0">
                    <Trans id={`card_${activeCardKey}_content_op1`} />
                  </h6>
                </div>
              </div>
            </li>
            <li className="py-2">
              <div className="d-flex align-items-center">
                <div>
                  <div className="badge badge-circle badge-primary mr-3">
                    <i className="ni ni-check-bold"></i>
                  </div>
                </div>
                <div>
                  <h6 className="mb-0">
                    <Trans id={`card_${activeCardKey}_content_op2`} />
                  </h6>
                </div>
              </div>
            </li>
            <li className="py-2">
              <div className="d-flex align-items-center">
                <div>
                  <div className="badge badge-circle badge-primary mr-3">
                    <i className="ni ni-check-bold"></i>
                  </div>
                </div>
                <div>
                  <h6 className="mb-0">
                    <Trans id={`card_${activeCardKey}_content_op3`} />
                  </h6>
                </div>
              </div>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};
